import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Redirect, Link } from 'react-router-dom';
import queryString from 'query-string';
import LINK from '@/utils/Constants/Link';
import { useProductRegistrationContext } from '@/product-registration/context';

// import api

// import hooks
import useBodyScrollToTop from '@/hooks/useBodyScrollToTop';
import useUpdateProductRegistrationWrapperClass from '@/product-registration/hooks/useUpdateProductRegistrationWrapperClass';
import useFirstRenderReveal from '@/hooks/useFirstRenderReveal';
import useLoadSelectPage from '@/product-registration/hooks/useLoadSelectPage';
import useFetchProducts from '@/product-registration/hooks/useFetchProducts';

// import components
import OrderProductBox from '@/components/organisms/OrderProductBox/OrderProductBox';

const ProductRegistrationSelect = ({ history }) => {
  const { t } = useTranslation();
  const [searchParams] = useState(queryString.parse(history.location.search));
  const [hasValidSearchParams] = useState(
    ['text', 'category'].some(
      k => k in searchParams && searchParams[k] !== null,
    ),
  );
  const [
    { productsLoading, products, selectedProduct, currentStep },
    { setSelectedProduct },
  ] = useProductRegistrationContext();
  const wrapperRef = useFirstRenderReveal(productsLoading);
  const hasEntries = products.length > 0;

  // hooks
  useBodyScrollToTop();
  useUpdateProductRegistrationWrapperClass('dln-prodReg--selectProduct');
  useLoadSelectPage();
  useFetchProducts(hasValidSearchParams, searchParams);

  // if text or category not in search url, redirect to search
  if (!hasValidSearchParams) {
    return <Redirect to={LINK.PRODUCT_REGISTRATION.SEARCH} />;
  }

  if (selectedProduct && currentStep === 1) {
    return (
      <Redirect
        push
        to={{
          pathname: LINK.PRODUCT_REGISTRATION.USER_DETAIL,
          search: `?code=${selectedProduct.code}${
            searchParams?.sn ? `&sn=${searchParams.sn}` : ''
          }`,
        }}
      />
    );
  }

  return (
    <div
      ref={wrapperRef}
      style={{ opacity: 0 }}
      className='dln-prodReg__content'
    >
      <Link
        to={LINK.PRODUCT_REGISTRATION.SEARCH}
        className='dln-btn dln-btn--link'
      >
        <i className='dln-icn dln-icn--iconfont'>s</i>
        {t('text.back')}
      </Link>
      <div className='clearer' />
      <h2 className='dln-prodReg__subTitle'>
        {t(
          `productRegistration:${
            hasEntries
              ? 'product.registration.select.title'
              : 'product.registration.select.empty.title'
          }`,
        )}
      </h2>
      {hasEntries && (
        <div className='dln-prodReg__productList'>
          <div className='dln-prodReg__productHeading'>
            <span>
              {t(
                'productRegistration:product.registration.select.product.label',
              )}
            </span>
            <span>
              {t('productRegistration:product.registration.select.sku.label')}
            </span>
          </div>
          {products.map(product => (
            <OrderProductBox
              key={product.code}
              modifiers={['productDescription']}
              product={{ ...product, serialNumber: searchParams?.sn || '' }}
              showSkuCode
              hasProductSelection
              onProductSelection={setSelectedProduct}
              simpleView
              isRegistrationProductSelect
            />
          ))}
        </div>
      )}
    </div>
  );
};

ProductRegistrationSelect.propTypes = {
  history: PropTypes.shape().isRequired,
};

export default ProductRegistrationSelect;
